import React, { useEffect, useState } from "react";
import "./MosqueView.css";
import Label from "../../../../components/Label";
import Input from "../../../../components/Input";
import { Button } from "react-bootstrap";
import { callApiV2 } from "../../../../util/apiCaller";
import CustomMultiSelect from "./CustomMultiSelect";
import { showNotification } from "../../../../util/Utility";
import { Formik, Form } from "formik";
import ErrorMessage from "../../../../components/ErrorMessage";
import * as Yup from "yup";
import axios from "axios";
import { useNavigate } from "react-router";
import DefaultModal from "../../../../components/DefaultModal/DefaultModal";
import Icon from "../../../../components/Icon";
import resetImg from "../../../../assets/images/reset-pwd.svg"
import ViewTab from "./ViewTab";

const formatEntityList = (list) => {
  return list
    ?.filter((item) => item.organisation_id?._id)
    .map((item) => ({
      label: item.name,
      value: item.organisation_id._id,
    }));
};

const validationSchema = Yup.object().shape({
  fullName: Yup.string().required("Full name is required"),
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
  selectedEntities: Yup.array()
    .min(1, "Please select at least one mosque")
    .max(5, "You can select up to 5 mosques"),
});

function MosqueView() {
  const [entitiesList, setEntitiesList] = useState([]);
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEntitiesList = async () => {
      try {
        const inputData = { pageSize: 1000 };
        const entList = await callApiV2({
          method: "post",
          endpoint: "entity/entity-list",
          body: inputData,
        });
        const formattedList = formatEntityList(entList?.data?.entityList);
        setEntitiesList(formattedList);
      } catch (error) {
        console.log(error);
      }
    };

    fetchEntitiesList();
  }, []);

  const initialValues = {
    fullName: "",
    email: "",
    selectedEntities: [],
  };

  const handleSubmit = async (values) => {
    try {
      const payload = {
        role: "viewer",
        contact_name: values.fullName.trim(),
        contact_email: values.email.trim(),
        is_onboarded: true,
        viewer_organisations: values.selectedEntities,
      };

      setEmail(values.email.trim());

      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };

      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}onboarding/viewer`,
        payload,
        config
      );
      if (res.status === 200) {
        setShowSuccessDialog(true);
      }
      // Add your API logic here
    } catch (error) {
      console.log("error: ", error);
      showNotification("error", "Some error occurred");
    }
  };

  

  return (
    <div className="viewer_container">
       <ViewTab/> 
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({
          values,
          handleChange,
          handleBlur,
          setFieldValue,
          touched,
          errors,
          isValid,
          dirty,
        }) => (
          <Form className="mosque_view_container">
            <Label className="mosque_view_title">
              Create mosque viewer account
            </Label>

            <div className="row" style={{ marginBottom: "34px" }}>
              <div className="col-lg-6">
                <Label className="mb-1">
                  Full Name <span style={{ color: "#FE1717" }}>*</span>
                </Label>
                <input
                  type="text"
                  name="fullName"
                  placeholder="Enter Full Name"
                  className="input-box"
                  value={values.fullName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {touched.fullName && errors.fullName && (
                  <ErrorMessage>{errors.fullName}</ErrorMessage>
                )}
              </div>

              <div className="col-lg-6">
                <Label className="mb-1">
                  Email Address <span style={{ color: "#FE1717" }}>*</span>
                </Label>
                <input
                  type="text"
                  name="email"
                  placeholder="Enter Email Address"
                  className="input-box"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {touched.email && errors.email && (
                  <ErrorMessage>{errors.email}</ErrorMessage>
                )}
              </div>
            </div>

            <div className="row" style={{ marginBottom: "100px" }}>
              <div className="col-lg-6">
                <CustomMultiSelect
                  options={entitiesList}
                  onChange={(selected) =>
                    setFieldValue("selectedEntities", selected)
                  }
                  label="Select Associated Mosques"
                />
                {touched.selectedEntities && errors.selectedEntities && (
                  <ErrorMessage>{errors.selectedEntities}</ErrorMessage>
                )}
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "center" }}>
              <button
                disabled={!(isValid && dirty)}
                className={!(isValid && dirty) ? "gray-bt" : "fill-bt"}
                variant={"secondary"}
                type="submit"
              >
                Next
              </button>
            </div>
          </Form>
        )}
      </Formik>
      <DefaultModal
        show={showSuccessDialog}
        onHide={() => {
          setShowSuccessDialog(false);
          navigate("/user/viewer_access");
        }}
        className="add-mosque-modal"
        centered={true}
        showHeader={false}
        size=""
        showFooter={false}
      >
        <>
          <Icon
            iconName="modalClose"
            iconSize="xs"
            style={{ marginLeft: "auto" }}
            onClick={() => {
              setShowSuccessDialog(false);
              navigate("/user/viewer_access");
            }}
          />
          <div className="text-center">
            <img src={resetImg} alt="success"/>
            <Label
              justifyContent="center"
              fontSize="20px"
              fontWeight={700}
              my="20px"
            >
              Set Password Link Sent
            </Label>
            <Label variant="text3" my="20px" color="#7E7E7E">
              {`We've sent a secure link to ${email}. Please check your inbox and follow the instructions to complete your account setup.`}
            </Label>
          </div>
        </>
      </DefaultModal>
    </div>
  );
}

export default MosqueView;
